import { TextInput } from '@mantine/core'
import { DatePickerInput } from '@mantine/dates'
import { useDebouncedCallback } from '@mantine/hooks'
import { useState } from 'react'

import type { DateRangeFilter } from './columns'
import { FILTER_STYLES } from './filterStyles'

export function DateRangeFilterInput(props: {
  value: DateRangeFilter | undefined
  onChange: (value: DateRangeFilter | undefined) => void
}) {
  const [range, setRange] = useState<DateRangeFilter>(props.value ?? [null, null])

  // Applied once the range is complete, so picking its first date doesn't send a request.
  return (
    <DatePickerInput
      type="range"
      aria-label="Filter by date"
      placeholder="Filter by date"
      value={range}
      onChange={next => {
        // Mantine empties a half-picked range when the calendar closes. Go back to the applied one.
        if (range[0] && !range[1] && !next[0]) {
          setRange(props.value ?? [null, null])
          return
        }
        setRange(next)
        if (next[0] && next[1]) props.onChange(next)
        else if (!next[0] && !next[1]) props.onChange(undefined)
      }}
      allowSingleDateInRange
      clearable
      valueFormat="MMM D, YYYY"
      size="sm"
      styles={FILTER_STYLES}
    />
  )
}

export function CommentFilterInput(props: {
  value: string | undefined
  onChange: (value: string | undefined) => void
}) {
  const [text, setText] = useState(props.value ?? '')
  const commit = useDebouncedCallback((next: string) => props.onChange(next || undefined), {
    delay: 500,
    flushOnUnmount: true,
  })

  return (
    <TextInput
      aria-label="Search comments"
      placeholder="Search comments..."
      value={text}
      onChange={event => {
        setText(event.currentTarget.value)
        commit(event.currentTarget.value)
      }}
      size="sm"
      styles={{ input: FILTER_STYLES.input }}
    />
  )
}
